import { render, staticRenderFns } from "./certificateEditModal.vue?vue&type=template&id=350ba5ac&"
import script from "./certificateEditModal.vue?vue&type=script&lang=js&"
export * from "./certificateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./certificateEditModal.vue?vue&type=style&index=0&id=350ba5ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports